module.exports = __webpack_public_path__ + "static/media/cloudy.cccda533.svg";